import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UtilsService {
    // emite fecha
    private _dateObs: Observable<Date>
  constructor() {
    this._dateObs = new Observable(observer => {
        //cada segundo genera la acción que es emiitir una nueva fecha
        setInterval(() => {
            observer.next ( new Date())
        }, 1000
        )
    })
  }

  // para que se pueda usar sin tener acceso al constructor
  get dateObs() {
    return this._dateObs
  }


  //totalComponent
  // el pipe permie que antes de la subscripción haga algo con los datos suscritos
  // inicialmente.
  // El método map devuelve cierto valor a la suscrpción siguiente
  /* this.cartService.products
    .pipe(
        map (products => {
            return products.reduce (
                (prev, curr) => prev + curr.price, 0
            )
        })
    )
    .subcribe(
        val => {
            aquí sale el valor antes calculado
        }
    ) */
}
